module.exports = __webpack_public_path__ + "static/assets/c032fce9224b20ad83c4b97ff0cb3fd4.gif";